<mat-form-field appearance="outline">
    <mat-label>{{ dataLabel }}</mat-label>

    <mat-select
        [formControl]="proxyControl"
        (openedChange)="filterSearchGroups()"
        [disableOptionCentering]="true"
        [multiple]="multiple"
        [compareWith]="compareWith">

        <mat-select-trigger *ngIf="multiple">
            {{ innerControl.value?.length > 0 ? innerControl.value.length + ' Selected' : '' }}
        </mat-select-trigger>

        <mat-option>
            <ngx-mat-select-search
                [formControl]="groupFilterControl"
                [placeholderLabel]="'Find ' + dataLabel + '...'"
                [noEntriesFoundLabel]="'No matching ' + (dataLabel | lowercase) + ' found'">
            </ngx-mat-select-search>
        </mat-option>
        <mat-optgroup
            *ngFor="let group of filteredDataGroups | async; trackBy: trackById"
            [label]="group.category.label">

            <mat-option
                *ngFor="let data of group.data; trackBy: trackById"
                [value]="data">

                <!-- THIS IS WHERE THE CUSTOM TEMPLATE IS INJECTED -->
                <ng-container *ngIf="optionTemplate; else defaultText">
                    <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: data }">
                    </ng-container>
                </ng-container>

                <ng-template #defaultText>
                    {{ data[searchLabel] }}
                </ng-template>
            </mat-option>

        </mat-optgroup>
    </mat-select>
    <mat-error>Select {{ dataLabel | lowercase }}</mat-error>
</mat-form-field>